import React from 'react'
import { IconButton } from '@mui/material'

import MaterialSymbol from '../../../components/MaterialSymbol'

export const ExpandIcon = ({ icon, onClick }: { icon: string; onClick: () => void }) => (
  <IconButton aria-label={icon} color='primary' onClick={onClick} sx={{ p: 0 }}>
    <MaterialSymbol>{icon}</MaterialSymbol>
  </IconButton>
)
